import uuid from '../../../services/uuid';
import uploadService from '../../../services/uploadService';

const API_BASE_URL = window.getApiUrl();

const dataURItoBlob = (dataURI: string): Blob => {
  const byteString = atob(dataURI.split(',')[1]);
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ia], {
    type: dataURI.split(',')[0].split(':')[1].split(';')[0],
  });
};

export const uploadTextStepImage = (description: string): Promise<string | undefined> => {
  const splits = description.split('<img src="data:');

  if (splits.length > 1) {
    const start = splits.shift();

    const fs = splits.map(function (s) {
      const indexOfCloseQuote = s.indexOf('"');

      if (indexOfCloseQuote > 0) {
        const imageData = s.slice(0, indexOfCloseQuote);
        return uploadImages('data:' + imageData).then(function (url) {
          return '<img src="' + url + '"' + s.slice(indexOfCloseQuote + 1);
        });
      } else {
        return Promise.resolve(s);
      }
    });

    return Promise.all(fs).then(function (updatedSplits) {
      return start + updatedSplits.join('');
    });
  } else {
    return Promise.resolve(description);
  }
};

const uploadImages = (base64data: string): Promise<string> => {
  if (!base64data) {
    throw new Error('uploadTextStepImage: empty data');
  }

  const dataType = base64data.split(',')[0].split(':')[1].split(';')[0];
  if (!dataType.startsWith('image/')) {
    throw new Error('uploadTextStepImage: unsupported data type');
  }

  const ext = dataType.split('/')[1];
  const key = `${uuid.generate()}.${ext.toLowerCase()}`;
  const blob = dataURItoBlob(base64data);

  return uploadService.uploadImage(blob, key).then(() => {
    return `${API_BASE_URL}/v1/storage/images/download?key=${key}`;
  });
};
